/**
 * Thèmes de couleur du fond « Vague » : un dégradé de haut en bas et la teinte des rubans (rgb). « Automatique » suit le mois,
 * comme le menu des consoles dont ce fond s'inspire. Calcul seulement (testable).
 */
export const THEMES = {
    bleu:   {nom: "Bleu",   haut: "#1a4fb5", bas: "#07173d", ruban: "190, 215, 255"},
    violet: {nom: "Violet", haut: "#5b2a9e", bas: "#1a0b3d", ruban: "220, 195, 255"},
    vert:   {nom: "Vert",   haut: "#1f8f4e", bas: "#06301a", ruban: "190, 255, 215"},
    cyan:   {nom: "Cyan",   haut: "#1aa6c9", bas: "#06303d", ruban: "190, 245, 255"},
    orange: {nom: "Orange", haut: "#e0731a", bas: "#4a1a06", ruban: "255, 225, 190"},
    rose:   {nom: "Rose",   haut: "#d8508f", bas: "#4a0f2a", ruban: "255, 205, 228"},
    rouge:  {nom: "Rouge",  haut: "#c0272d", bas: "#3d0709", ruban: "255, 200, 200"},
    or:     {nom: "Or",     haut: "#c8a428", bas: "#3d2f06", ruban: "255, 242, 190"},
    gris:   {nom: "Argent", haut: "#7d8794", bas: "#1c2026", ruban: "232, 238, 245"},
};

/** Thème de chaque mois (0 = janvier), dans l'ordre des saisons. */
export const MOIS = ["gris", "or", "rose", "vert", "vert", "cyan", "cyan", "orange", "orange", "violet", "rouge", "bleu"];

export const themeDuMois = date => MOIS[date.getMonth()];

/** Thème à afficher : celui demandé, ou celui du mois si « auto » (ou si la valeur est inconnue). */
export function themeChoisi(valeur, date) {
    return THEMES[valeur] ? valeur : themeDuMois(date);
}
